import { registerLocaleData } from '@angular/common';
import localeBG from '@angular/common/locales/bg';
import { Component, NgZone, OnInit, ViewChild, effect } from '@angular/core';
import { NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { ISelectionEventArgs, changei18n } from '@infragistics/igniteui-angular';
import { IgxResourceStringsBG } from 'igniteui-angular-i18n';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './authentication/user.service';
import { Message, MessagesService } from './services/messages.service';
import { WaitIndicatorService } from './services/wait-indicator.service';
import { WaitIndicatorComponent } from './shared/wait-indicator/wait-indicator.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    @ViewChild('waitIndicator', { static: true, read: WaitIndicatorComponent})
    private waitIndicator?: WaitIndicatorComponent;

    public messages: Message[] = [];
    public removedMessages: Message[] = [];
    public isPublic = false;
    public name = environment.name;

    constructor(
        public userService: UserService,
        public messagesService: MessagesService,
        private loadingIndicatorService: WaitIndicatorService,
        private router: Router,
        private zone: NgZone,
    ) {
        messagesService.added.subscribe(v => {
            this.messages.push(v);
        });
        messagesService.removed.subscribe(v => {
            this.messages.splice(this.messages.indexOf(v), 1);
            this.removedMessages.push(v);
        });
        effect(() => {
            if (this.loadingIndicatorService.loading()) this.waitIndicator?.show();
            else this.waitIndicator?.hide();
        });
        router.events
            .pipe(filter(e => e instanceof RoutesRecognized || e instanceof NavigationStart))
            .subscribe(e => {
                if (e instanceof RoutesRecognized) {
                    this.isPublic = e.urlAfterRedirects === '/enroll';
                }
                if (e instanceof NavigationStart) {
                    this.isPublic = e.url === '/enroll';
                }
        });
    }

    public menuSelect(args: ISelectionEventArgs) {
        switch (args.newSelection.index) {
            case 0:
                this.router.navigate(['user-profile']);
                break;
            case 1:
                this.userService.logout();
                this.router.navigate(['authentication']);
                break;
        }
    }

    ngOnInit(): void {
        changei18n(IgxResourceStringsBG);
        registerLocaleData(localeBG);
    }

    despawnMsg(id: string) {
        this.zone.run(() => {
            this.removedMessages = this.removedMessages.filter(v => v.id !== id);
        })
    }
}
